import './Checkbox.css';

export default function Checkbox({
    handleCheckboxChange,
    checked,
    id, 
    colorBody,
    colorBall='#ffff00e6',
  })   {
    return(    
           <div>        
            <input type='checkbox' className="ToggleCheckbox"
             style={{ '--body-color': colorBody }}
             checked={checked || false}
             onChange={handleCheckboxChange}
             id={id} />
            <label for={id}
             style={{ '--body-color': colorBody, '--ball-color': colorBall }}></label>
          </div>              
    )
}

